// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-DayPage-__TideGraphLegend-module___container","item":"src-components-DayPage-__TideGraphLegend-module___item","icon":"src-components-DayPage-__TideGraphLegend-module___icon","height":"src-components-DayPage-__TideGraphLegend-module___height"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DayPage/TideGraphLegend.module.css
// module id = 1338
// module chunks = 0